import { render, staticRenderFns } from "./LotteryDayHistory.vue?vue&type=template&id=63b0af64&scoped=true"
import script from "./LotteryDayHistory.vue?vue&type=script&lang=js"
export * from "./LotteryDayHistory.vue?vue&type=script&lang=js"
import style0 from "./LotteryDayHistory.vue?vue&type=style&index=0&id=63b0af64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0af64",
  null
  
)

export default component.exports